import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminMessages } from "@/components/AdminMessages";
import { AdminWaitlist } from "@/components/AdminWaitlist";
import { AdminStoreLinks } from "@/components/AdminStoreLinks";
import { AdminScreenshots } from "@/components/AdminScreenshots";
import { AdminDeletions } from "@/components/AdminDeletions";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState(() => sessionStorage.getItem("zenvio-admin") || "");
  const [msgs, setMsgs] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.get(`${API}/contact`, { headers: { "X-Admin-Key": key } });
      sessionStorage.setItem("zenvio-admin", key);
      setMsgs(data);
    } catch {
      setError("Invalid admin key");
      setMsgs(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-page" className="container-x min-h-[80vh] pb-24 pt-36">
      <p className="eyebrow">Inbox</p>
      <h1 className="mt-4 font-display text-4xl font-extrabold tracking-[-0.04em] sm:text-6xl">Messages</h1>
      <form onSubmit={load} className="mt-10 flex max-w-lg gap-3">
        <input type="password" value={key} onChange={(e) => setKey(e.target.value)} placeholder="Admin key" data-testid="admin-key-input" className="flex-1 rounded-full border border-white/15 bg-white/5 px-5 py-3 outline-none focus:border-[#22d3ee]" />
        <button type="submit" data-testid="admin-load-button" className="btn-primary">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Open"}</button>
      </form>
      {error && <p data-testid="admin-error" className="mt-4 text-sm text-rose-400">{error}</p>}
      {msgs && (
        <Tabs defaultValue="messages" className="mt-12">
          <TabsList className="h-auto flex-wrap rounded-[24px] bg-white/5 p-1">
            <TabsTrigger value="messages" data-testid="admin-tab-messages" className="rounded-full px-5">Messages ({msgs.length})</TabsTrigger>
            <TabsTrigger value="waitlist" data-testid="admin-tab-waitlist" className="rounded-full px-5">Launch lists</TabsTrigger>
            <TabsTrigger value="links" data-testid="admin-tab-links" className="rounded-full px-5">Store links</TabsTrigger>
            <TabsTrigger value="shots" data-testid="admin-tab-screenshots" className="rounded-full px-5">Screenshots</TabsTrigger>
            <TabsTrigger value="deletions" data-testid="admin-tab-deletions" className="rounded-full px-5">Deletion requests</TabsTrigger>
          </TabsList>
          <TabsContent value="messages" className="mt-8"><AdminMessages msgs={msgs} adminKey={key} onChange={load} /></TabsContent>
          <TabsContent value="waitlist" className="mt-8"><AdminWaitlist adminKey={key} /></TabsContent>
          <TabsContent value="links" className="mt-8"><AdminStoreLinks adminKey={key} /></TabsContent>
          <TabsContent value="shots" className="mt-8"><AdminScreenshots adminKey={key} /></TabsContent>
          <TabsContent value="deletions" className="mt-8"><AdminDeletions adminKey={key} /></TabsContent>
        </Tabs>
      )}
    </div>
  );
}
